import { useGetCompanies, UseGetCompaniesOptions } from './useGetCompanies'

const useGetParentCompanies = (searchTerm?: string, options?: UseGetCompaniesOptions) => {
  return useGetCompanies(
    {
      hasChildren: true,
      sort: [{ field: 'name', direction: 'asc' }],
      ...(searchTerm ? { name: { contains: searchTerm } } : {}),
    },
    options,
  )
}

export { useGetParentCompanies }
